import { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function EvaluationSettings() {
  const [s, setS] = useState(null);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => { api.get('/evaluations/settings').then(setS).catch((e) => setError(e.message)); }, []);
  if (!s) return <div className="panel"><div className="panel-body"><div className="empty">Chargement…</div></div></div>;
  const set = (k) => (e) => { setS({ ...s, [k]: e.target.value }); setSaved(false); };

  async function save(e) {
    e.preventDefault(); setError('');
    try { const r = await api.patch('/evaluations/settings', s); setS(r); setSaved(true); } catch (err) { setError(err.message); }
  }

  return (
    <div className="panel">
      <div className="panel-head"><h2>Paramètres d'évaluation</h2>{saved && <span className="badge green">Enregistré ✓</span>}</div>
      <div className="panel-body" style={{ padding: 18 }}>
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={save}>
          <div className="fieldset-title">Barème & passage</div>
          <div className="grid-3">
            <div className="field"><label>Barème (note max)</label><input type="number" min="1" value={s.scaleMax} onChange={set('scaleMax')} /></div>
            <div className="field"><label>Moyenne de passage</label><input type="number" step="0.5" value={s.passMark} onChange={set('passMark')} /></div>
            <div className="field"><label>Décimales d'arrondi</label><input type="number" min="0" max="2" value={s.rounding} onChange={set('rounding')} /></div>
          </div>
          <div className="fieldset-title">Seuils de mention</div>
          <div className="grid-3">
            <div className="field"><label>Passable ≥</label><input type="number" step="0.5" value={s.mentionPassable} onChange={set('mentionPassable')} /></div>
            <div className="field"><label>Assez bien ≥</label><input type="number" step="0.5" value={s.mentionAssezBien} onChange={set('mentionAssezBien')} /></div>
            <div className="field"><label>Bien ≥</label><input type="number" step="0.5" value={s.mentionBien} onChange={set('mentionBien')} /></div>
            <div className="field"><label>Très bien ≥</label><input type="number" step="0.5" value={s.mentionTresBien} onChange={set('mentionTresBien')} /></div>
          </div>
          <div style={{ marginTop: 16 }}><button className="btn" type="submit" style={{ width: 'auto', padding: '0 22px' }}>Enregistrer</button></div>
          <p style={{ color: 'var(--muted)', fontSize: '0.82rem', marginTop: 10 }}>Ces seuils déterminent la mention et le passage affichés sur les bulletins.</p>
        </form>
      </div>
    </div>
  );
}
